import { render, staticRenderFns } from "./CourierMapTable.vue?vue&type=template&id=29c291d6&"
import script from "./CourierMapTable.vue?vue&type=script&lang=ts&"
export * from "./CourierMapTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CourierMapTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports